"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeInput = RangeInput;

var _fieldAlert = require("../field-alert");

var _fieldError = require("../field-error");

var _fieldsStyledComponents = require("../fields-styled-components");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _reactForms = require("@seegno/react-forms");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["className", "disabled", "helpText", "id", "label", "max", "min", "name", "step"],
    _excluded2 = ["error", "onChange", "value"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Get progress.
 */
function getProgress(value, max, min) {
  return "".concat((value - min) / (max - min) * 100, "%");
}
/**
 * Thumb styles.
 */


var thumbStyles = (0, _styledComponents.css)(["appearance:none;background-color:var(--progressBg);border:none;border-radius:calc(var(--thumbSize) / 2);cursor:pointer;height:var(--thumbSize);margin-top:calc(((var(--thumbSize) - var(--trackSize)) / 2) * -1);width:var(--thumbSize);"]);
/**
 * Progress styles.
 */

var progressStyles = function progressStyles(_ref) {
  var max = _ref.max,
      min = _ref.min,
      value = _ref.value;
  return (0, _styledComponents.css)(["background:linear-gradient(90deg,var(--progressBg) ", ",var(--trackBg) ", ");border-radius:", "px;height:var(--trackSize);"], getProgress(value, max, min), getProgress(value, max, min), (0, _styledTools.theme)('dimensions.borderRadius'));
};
/**
 * `StyledFormGroup` styled component.
 */


var StyledFormGroup = (0, _styledComponents["default"])(_fieldsStyledComponents.FormGroup).withConfig({
  displayName: "range-input__StyledFormGroup",
  componentId: "sc-1k810fl-0"
})(["--thumbSize:24px;--trackSize:8px;--trackBg:", ";--progressBg:", ";"], (0, _styles.color)('blue100'), (0, _styles.color)('primary'));
/**
 * `RangeSilder` styled component.
 */

var RangeSilder = _styledComponents["default"].input.withConfig({
  displayName: "range-input__RangeSilder",
  componentId: "sc-1k810fl-1"
})(["appearance:none;display:block;min-height:var(--thumbSize);width:100%;&::-webkit-slider-thumb{", "}&::-moz-range-thumb{", "}&::-webkit-slider-runnable-track{", "}&::-moz-range-track{", "}&:hover,&:focus{&::-webkit-slider-thumb{box-shadow:0 0 0 8px var(--trackBg);}&::-moz-range-thumb{box-shadow:0 0 0 8px var(--trackBg);}}"], thumbStyles, thumbStyles, progressStyles, progressStyles);
/**
 * Export `RangeInput` component.
 */


function RangeInput(props) {
  var className = props.className,
      disabled = props.disabled,
      helpText = props.helpText,
      id = props.id,
      label = props.label,
      _props$max = props.max,
      max = _props$max === void 0 ? 100 : _props$max,
      _props$min = props.min,
      min = _props$min === void 0 ? 0 : _props$min,
      name = props.name,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      rest = _objectWithoutProperties(props, _excluded);

  var _useField = (0, _reactForms.useField)(name),
      error = _useField.error,
      onChange = _useField.onChange,
      _useField$value = _useField.value,
      value = _useField$value === void 0 ? 0 : _useField$value,
      fieldProps = _objectWithoutProperties(_useField, _excluded2);

  var _useFormState = (0, _reactForms.useFormState)(),
      alreadySubmitted = _useFormState.alreadySubmitted,
      isSubmitting = _useFormState.isSubmitting;

  var hasError = !!error && alreadySubmitted;
  var isDisabled = disabled || isSubmitting;
  var handleChange = (0, _react.useCallback)(function (event) {
    var value = event.target.value;
    onChange(Number(value));
  }, [onChange]);
  return /*#__PURE__*/_react["default"].createElement(StyledFormGroup, {
    className: className,
    disabled: isDisabled
  }, /*#__PURE__*/_react["default"].createElement(RangeSilder, _extends({}, fieldProps, rest, {
    "aria-label": label,
    id: id !== null && id !== void 0 ? id : name,
    max: max,
    min: min,
    onChange: handleChange,
    step: step,
    type: 'range',
    value: value
  })), helpText && /*#__PURE__*/_react["default"].createElement(_fieldAlert.FieldAlert, {
    isOpen: !hasError
  }, helpText), /*#__PURE__*/_react["default"].createElement(_fieldError.FieldError, {
    error: error,
    isOpen: hasError,
    name: name
  }));
}